import { Shape } from "three";
import { archNotch } from "../geometry/arch";
import { straightRun } from "../geometry/path";
const ARCH_CLEARANCE = 0.06;
function cabProfile(d) {
  const nose = d.length / 2;
  const rear = nose - d.cabLength;
  const archRadius = d.wheelRadius + ARCH_CLEARANCE;
  const [screenLowX, screenLowY] = d.windscreenLower;
  const [screenHighX, screenHighY] = d.windscreenUpper;
  const s = new Shape();
  s.moveTo(rear, d.cabFloorY);
  archNotch(s, {
    axleX: d.axles[0].x,
    hubY: d.wheelRadius,
    radius: archRadius,
    edgeY: d.cabFloorY
  });
  straightRun(s, nose - 0.12, d.cabFloorY);
  s.quadraticCurveTo(nose, d.cabFloorY, nose, d.cabFloorY + 0.3);
  straightRun(s, screenLowX, screenLowY);
  straightRun(s, screenHighX, screenHighY);
  s.quadraticCurveTo(screenHighX - 0.14, d.cabRoofY, screenHighX - 0.32, d.cabRoofY);
  straightRun(s, rear + 0.16, d.cabRoofY);
  s.quadraticCurveTo(rear, d.cabRoofY, rear, d.cabRoofY - 0.24);
  straightRun(s, rear, d.cabFloorY);
  return s;
}
export {
  cabProfile
};
